<template>
  <div class="line-gauge">
    <div class="lg-position" v-bind:style="styleBindings" v-if="value > 0"></div>
  </div>
</template>

<script>
  export default {
    name: 'line-gauge',

    props: {
      value: {
        type: Number,
        default: 50,
      },
      bgColor: {
        type: String,
        default: '#00c896',
      },
    },

    computed: {
      styleBindings() {
        return {
          width: `${this.value}%`,
          'background-color': this.bgColor,
          'border-color': this.bgColor,
        };
      },
    },
  };
</script>

<style lang="scss">
  .line-gauge {
    position: relative;
    background-color: #EEEEEE;
    border-radius: 25px;
    height: 8px;
    z-index: 1;

    .lg-position {
      position: relative;
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
      height: 8px;
      z-index: 2;

      &:after {
        content: '';
        border-right: solid 2px;
        border-color: inherit;
        height: 12px;
        position: absolute;
        top: -2px;
        right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// LineGauge.vue?e9de8452